
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="danger" size="medium" class="operator-btn3" icon="el-icon-circle-plus-outline" @click="handleCreateOneDlg()">新增职位</el-button>
      </div>
    </div>
    <div class="table-container" shadow="never" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        max-height="580"
        v-loading="listLoading" border
        @row-click="rowClick">
        <el-table-column type="selection" width="120"></el-table-column>
        <el-table-column prop="name" label="职位" width="240"></el-table-column>
        <el-table-column prop="power" label="权重" width="120"></el-table-column>
        <el-table-column prop="power" label="提成模板" >
          <template slot-scope="scope">
            <el-select v-if="scope.row.cfCommissonId >0" v-model="scope.row.cfCommissonId" placeholder="无模板" style="width: 200px;">
              <el-option
                v-for="item in salaryCommissonTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-if="scope.row.bsCommissonId >0" v-model="scope.row.bsCommissonId" placeholder="无模板" style="width: 200px;">
              <el-option
                v-for="item in salaryCommissonTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-if="scope.row.commissonId >0" v-model="scope.row.commissonId" placeholder="无模板" style="width: 200px;">
              <el-option
                v-for="item in salaryCommissonTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click="handleUpdateOneDlg(scope.row)" type="warning" plain size="small">修改</el-button>
            <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="新增职位"
      :visible.sync="visibleDlgAdd"
      width="50%"
      center>
      <div class="root-container">
        <el-form ref="refInputWorker" :model="createParam" label-width="140px">
          <el-form-item  label="职位名称:" >
            <el-input  maxlength="10" show-word-limit v-model="createParam.name" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item  label="权重:" >
            <el-input-number  maxlength="10"  show-word-limit v-model="createParam.power" placeholder="" style="width: 300px;"></el-input-number>
          </el-form-item>
          <el-form-item  label="薪资模板:" >
            <el-checkbox-group v-model="selectTemplateList">
              <div v-for="item in salaryCommissonTemplateList">
                <el-checkbox :value="item.id" :label="item.name"></el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改职位信息"
      :visible.sync="visibleDlgUpdate"
      width="50%"
      center>
      <div class="root-container">
        <el-form  label-width="140px" >
          <el-form-item  label="职位:" >
            <el-input readonly="true"  maxlength="10"  show-word-limit v-model="selectRow.name" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item  label="权重:" >
            <el-input-number  maxlength="10"  show-word-limit v-model="selectRow.power" placeholder="" style="width: 300px;"></el-input-number>
          </el-form-item>
          <el-form-item  label="薪资模板:" >
            <el-checkbox-group v-model="selectTemplateList">
              <div v-for="item in salaryCommissonTemplateList">
                <el-checkbox :value="item.id" :label="item.name"></el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgUpdate = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateOne">保存</el-button>
      </span>
    </el-dialog>
  </div>


</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import {addposition, delWorkerPosition, selectWorkerPosition, updateposition} from "../../../api/storeFront";
  import commonUtils from "../../../utils/commonUtils";
  import messageUtils from "../../../utils/messageUtils";
  import {selectAllCmi} from "../../../api/salary/SalaryCommisson";
  import enumsUtil from "../../../utils/enumsUtil";

  export default {
    data() {
      return {
        visibleDlgAdd :false,
        visibleDlgUpdate :false,
        //表单结果
        tableData: [
        ],
        listLoading: true,
        createParam:{
          name:'',
          power:0,
          bsCommissonId:null,
          bsCommissonId:null,
          cfCommissonId:null,
        },
        selectRow:"",
        salaryCommissonTemplateList:[],

        selectTemplateList:[]




      }
    },
    mounted() {
      this.getAllCmi();

    },
    methods: {
      rowClick(row, column, event){
        this.selectRow = row;
      },

      getAllCmi(){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        selectAllCmi(param).then(response =>
        {
          let list = response.data;
          if (commonUtils.isObjectNull(list)){
            return;
          }
          this.salaryCommissonTemplateList = [];


          for (let i =0;i<list.length;++i ){
            this.salaryCommissonTemplateList.push(list[i])
          }

          this.flechList();
        })
      },

      handleCheckSelectRow(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条数据")
          return false;
        }
        return this;
      },

      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        const loading = this.myLoading();
        selectWorkerPosition(param).then(response => {
          this.listLoading = false;
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.refreshData(data);

        })
      },
      //刷新页面数据
      refreshData(data){
        if (commonUtils.isObjectNull(data)){
          return;
        }
        if (data.length>0){
          data.sort(function(a,b){
            return a.power-b.power});
        }
        this.tableData = data;


      },
      handleDeleteOne(row){
        this.$confirm('是否要删除该职位?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {id:row.id}
          delWorkerPosition(param).then(response => {
            let data = response.data;
            if (commonUtils.isObjectNull(data)){
              return;
            }
            if (data == true){
              messageUtils.successMsg(this,response.message)
            } else {
              messageUtils.errorMsg(this,response.message)
            }
            this.flechList();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
      },

      //添加
      handleCreateOneDlg(){
        this.selectTemplateList = []
        this.visibleDlgAdd = true;
      },
      handleCreateOne(){
        if (commonUtils.isStringNull(this.createParam.name)){
          messageUtils.errorMsg(this,"请输入职位")
          return ;
        }

         //不能添加重复的
        for(let i = 0;i< this.tableData.length;++i){
          if (this.createParam.name == this.tableData[i].name) {
            messageUtils.errorMsg(this,"不能添加重复的职位")
            return ;
          }
        }
        if (this.tableData.length >= 20){
          messageUtils.errorMsg(this,"最多只能添加20个职位")
        }
        let param = {
          storeFrontId : globaldata.getAdminStore().storeFrontId ,
          power:this.createParam.power,
          name:this.createParam.name,
          commissonIdList:this.getSelectTemplateSameType()
        };
        const loading = this.myLoading();
        addposition(param).then(response =>
        {
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }
          this.visibleDlgAdd = false;
          this.flechList();

        })

      },

      //修改
      handleUpdateOneDlg(row){
        this.selectRow = row;
        if (!this.handleCheckSelectRow()){
          return;
        }
        this.setSelectTemplateFromRow(this.selectRow);
        this.visibleDlgUpdate = true;
      },
      handleUpdateOne(){

        let param = {
          storeFrontId : globaldata.getAdminStore().storeFrontId ,
          power:this.selectRow.power,
          name:this.selectRow.name,
          id:this.selectRow.id,
          commissonIdList:this.getSelectTemplateSameType()
        };
        const loading = this.myLoading();
        this.$confirm('是否要修改该职位?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateposition(param).then(response => {
            loading.close();
            let data = response.data;
            if (commonUtils.isObjectNull(data)){
              return;
            }
            if (data == true){
              messageUtils.successMsg(this,response.message)
            } else {
              messageUtils.errorMsg(this,response.message)
            }
            this.visibleDlgUpdate = false;
            this.flechList();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消修改'
          });
        });
      },

      /**
       * 检测选择的模板列表是否业务类型冲突 (如果选择了不区分的，那么就不能选择其他的了)
       */
      getSelectTemplateSameType(){
        let slist=[];
        for (let i =0;i< this.selectTemplateList.length;++i){
          let name = this.selectTemplateList[i];
          for (let j = 0;j<this.salaryCommissonTemplateList.length;++j){
             let salaryTemp = this.salaryCommissonTemplateList[j];
             if (name == salaryTemp.name){
               slist.push(salaryTemp.id);
             }
          }
        }
        return slist;
      },
      setSelectTemplateFromRow(row){
        this.selectTemplateList = [];
        for (let j = 0;j<this.salaryCommissonTemplateList.length;++j){
          let salaryTemp = this.salaryCommissonTemplateList[j];
          if (row.cfCommissonId == salaryTemp.id){
            this.selectTemplateList.push(salaryTemp.name);
          }else  if (row.bsCommissonId == salaryTemp.id){
            this.selectTemplateList.push(salaryTemp.name);
          }else  if (row.commissonId == salaryTemp.id){
            this.selectTemplateList.push(salaryTemp.name);
          }
        }
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/worker-positions/index.vue